<template>
    
    <spinner v-if="!loaded" ></spinner>

    <div class="leads-conversions-template" v-else-if="loaded" > 
        
        <div class="row" >
            <div class="col-12" >
                <b-input-group>
                    <b-form-input v-model="filter" placeholder="Search by email, name or phone" class="search-input atlass-input-borderless" v-on:keyup.enter="searchInDB()" />
                    
                    <font-awesome-icon icon="times-circle" @click="resetSearch()" class="reset-filter mr-" v-bind:class="{ 'd-none' : !filter }" >Clear</font-awesome-icon>
                    
                    <font-awesome-icon @click="searchInDB()" icon="search" class="ml-4 cursor-pointer" style="font-size:1.1em; margin-top:9px; opacity:.75;"  :id="`tooltip--searchindatabase-button`"  > Search in DB </font-awesome-icon>
                    <b-tooltip :target="`tooltip--searchindatabase-button`" placement="left" triggers="hover" custom-class="tooltip-auto"   > Search in database <span v-if="!filter" > ( type something first ) </span> </b-tooltip>
                    
                    <a @click="get_new_data" class="ml-4" :id="`tooltip--getlatestleads-button`" > <font-awesome-icon icon="sync" style="font-size:1.1em; margin-top:9px; opacity:.75;" > Refresh </font-awesome-icon> </a>
                    <b-tooltip :target="`tooltip--getlatestleads-button`" placement="bottom" triggers="hover" custom-class="tooltip-auto"   > Refresh data ( load latest leads ) </b-tooltip>
                    
                    <a @click="load_more" class="ml-4 d-none" :id="`tooltip--allleads-button`" > <font-awesome-icon icon="align-justify" style="font-size:1.1em; margin-top:9px; opacity:.75;" > Load all </font-awesome-icon> </a>
                    <b-tooltip :target="`tooltip--allleads-button`" placement="bottom" triggers="hover" custom-class="tooltip-auto"  > Load all leads </b-tooltip>
                    
                </b-input-group>
            </div>
        </div>
        
        <spinner v-if="!dataLoaded" ></spinner>
                
        <vue-good-table
            v-else-if="dataLoaded"
            class=""
            :columns="columns"
            :rows="rows"
            styleClass="vgt-table atlass-datatable leads-table"
            :search-options="{ enabled: true, externalQuery: filter }"
            :pagination-options="paginationOptions"
            :selectOptions="{
                enabled: false,
                selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
              }"
            @on-row-click="routeUser"
            @on-page-change="onPageChange"
             >
            
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'email'">
                    {{props.row.email}}  
                    <font-awesome-icon v-if="props.row.primary_lead" :icon="['fa', 'link']" class="graymedium-color" :id="`lead-tooltip--${props.row.id}`" />
                    <b-tooltip :target="`lead-tooltip--${props.row.id}`" placement="right" triggers="hover"  >
                        This lead is a child for primary lead {{props.row.primary_email}}
                    </b-tooltip>
                </span>

                <span v-else-if="props.column.field == 'name'">
                        
                    {{props.row.name}}  

                    <font-awesome-icon :icon="['fa', 'shopping-cart']" class="graymedium-color" :id="`order-tooltip--${props.row.id}`" v-if="props.row.orderItems" />
                    <b-tooltip :target="`order-tooltip--${props.row.id}`" placement="right" triggers="hover"  >
                        <span v-for="item in props.row.orderItems"  >
                            <span> {{item.Name}} ( {{item.tag}} ) </span> <br>
                        </span>
                    </b-tooltip>

                </span>


                
                <span v-else-if="props.column.field == 'firstTouch'">
                    <img v-if="props.row.firstTouch.origin == 'FACEBOOK'" src="@/assets/icons/facebook.png" :id="`tooltip--firstTouch-${props.row.id}`" style="height:15px;width:15px;" /> 
                    <img v-else-if="props.row.firstTouch.origin == 'GOOGLE'" src="@/assets/icons/googleadwords.png" :id="`tooltip--firstTouch-${props.row.id}`" style="height:15px;width:15px;"  /> 
                    <img v-else-if="props.row.firstTouch.origin == 'TIKTOK'" src="@/assets/icons/tiktok.png" :id="`tooltip--firstTouch-${props.row.id}`" style="height:15px;width:15px;"  /> 
                    <!--
                    <b-tooltip :target="`tooltip--firstTouch-${props.row.id}`" placement="right" triggers="hover" >                                    
                         {{ props.row.firstTouch }}  
                    </b-tooltip>
                    -->
                    <span v-if="props.row.firstTouch.tag  " :id="`tooltip--${props.column.field}--${props.row.id}`" > {{ renderTag( props.row.firstTouch ) }} </span>
                    <b-tooltip :target="`tooltip--${props.column.field}--${props.row.id}`" placement="bottom" triggers="hover"  >
                        {{ props.row.firstTouch.tag }}
                    </b-tooltip>
                    
                </span>
                
                <span v-else-if="props.column.field == 'lastTouch'">
                    <img v-if="props.row.touchpoints.length > 0 && props.row.touchpoints[ props.row.touchpoints.length - 1 ].origin == 'FACEBOOK'" src="@/assets/icons/facebook.png" :id="`tooltip--lastTouch-${props.row.id}`" style="height:15px;width:15px;" /> 
                    <img v-else-if="props.row.touchpoints.length > 0 && props.row.touchpoints[ props.row.touchpoints.length - 1 ].origin == 'GOOGLE'" src="@/assets/icons/googleadwords.png" :id="`tooltip--lastTouch-${props.row.id}`" style="height:15px;width:15px;"  /> 
                    <img v-else-if="props.row.touchpoints.length > 0 && props.row.touchpoints[ props.row.touchpoints.length - 1 ].origin == 'TIKTOK'" src="@/assets/icons/tiktok.png" :id="`tooltip--lastTouch-${props.row.id}`" style="height:15px;width:15px;"  /> 
                    
                    <span v-if="props.row.touchpoints.length > 0 " :id="`tooltip--${props.column.field}--${props.row.id}`" > {{ renderTag( props.row.touchpoints[ props.row.touchpoints.length - 1 ] ) }} </span>
                    <b-tooltip :target="`tooltip--${props.column.field}--${props.row.id}`" placement="bottom" triggers="hover" v-if="props.row.touchpoints.length > 0 " >
                        {{ props.row.touchpoints[ props.row.touchpoints.length - 1 ].tag }}
                    </b-tooltip>
                    
                    <font-awesome-icon :icon="['fas', 'tags']" class="graymedium-color" :id="`order-tooltip--touchpoints--${props.row.id}`" v-if="props.row.touchpoints.length > 0" />
                    <b-tooltip :target="`order-tooltip--touchpoints--${props.row.id}`" placement="right" triggers="hover"  >
                        
                        <span class="d-block" v-for="(touchpoint, index) in props.row.touchpoints" >
                            
                            {{ formatDate(touchpoint) }} - 
                            <img v-if="touchpoint.origin == 'FACEBOOK'" src="@/assets/icons/facebook.png" style="height:15px;width:15px;" /> 
                            <img v-else-if="touchpoint.origin == 'GOOGLE'" src="@/assets/icons/googleadwords.png" style="height:15px;width:15px;"  /> 
                            <img v-else-if="touchpoint.origin == 'TIKTOK'" src="@/assets/icons/tiktok.png" style="height:15px;width:15px;"  /> 
                            {{ touchpoint.name }} 

                        </span>
                        
                    </b-tooltip>
                    
                </span>
                
                
                <span v-else-if="props.column.field == 'status'">
                    <b-badge v-if="props.row.status == 'completed'" variant="success">completed</b-badge>
                    <b-badge v-else-if="props.row.status == 'refunded'"  variant="danger">refunded</b-badge>
                    <b-badge v-else-if="props.row.status == 'failed'"  variant="danger">failed</b-badge>
                    <b-badge v-else-if="props.row.status != ''"  variant="secondary"> {{props.row.status}} </b-badge>
                </span>
                
            </template>
            
        </vue-good-table>
          
        
        <modal :modalData="modalData" :modalState="modalState" modalComponent="lead" ></modal>
    
    </div>
</template>

<script>    
import Cookies from 'js-cookie'
import modal from '@/components/modal.vue'  
import helper from '@/helpers/helpers.js';
    
export default{
    name: "orders",
    props: {
        passed_organizationID: { 
            type: [String],
        },
        data: { 
            type: [Array],
        },
        page:{
            type:[String],
            default: "orders"
        }
    },
    components:{
        modal: () => import('@/components/modal.vue')
    },
    data () {
        return {
            filter: '',
            columns: [
                {
                    label: 'EMAIL',
                    field: 'email',
                    //field: this.LeadEmail,
                    html:true,
                    tdClass: 'font-800',
                    thClass: 'font-800',
                },
                {
                    label: 'CONVERSION NAME',
                    field: 'name',
                    //field: this.returnName,
                    tdClass: 'font-800',
                    thClass: 'font-800',
                },

                {
                    label: 'PHONE',
                    field: 'phone',
                    hidden: true,
                    //field: this.returnName,
                },
                {
                    label: 'FIRST SOURCE',
                    //field: this.returnFirstSource,
                    field: 'firstTouch',
                    hidden: true,
                    //formatFn: this.renderTag,
                },
                {
                    //label: 'LAST SOURCE',
                    label: 'TOUCHPOINTS ( LAST )',
                    //field: this.returnLastSource,
                    field: 'lastTouch',
                    //formatFn: this.renderTag,
                },
                
                {
                    label: 'PRICE',
                    field: 'price',
                    type: 'number',
                    //field: this.returnName,
                },
                {
                    label: 'STATUS',
                    field: 'status',
                    //field: this.returnName,
                    //type: 'number',
                    tdClass: 'text-right',
                    thClass: 'text-right',
                },
                {
                    label: 'CREATED',
                    field: this.formatDate,
                    tdClass: 'text-right',
                    thClass: 'text-right',
                },
            ],
            storedRows: [],
            rows: [],
            loaded: false,
            dataLoaded: false,
            modalData: null,
            modalState: false,
            paginationOptions:{ 
                enabled: true,
                perPage: 20,
                perPageDropdown: [50, 100],
                dropdownAllowAll: true,
                setCurrentPage: 1,
                nextLabel: 'next',
                prevLabel: 'prev',
                rowsPerPageLabel: 'Leads per page',
                ofLabel: 'of',
                pageLabel: 'page', // for 'pages' mode
                allLabel: 'All',
                perPageDropdownEnabled: false,
            },
            currentPage: 1,
            ID: null
        }
    },
    beforeCreate: function (){
       // this.$store.dispatch(GET_USERS);
    },
    mounted: function(){
        
        //console.log(this.data)
        
        if( ( this.data == null || this.data.length == 0 ) && this.page != 'orders' ){
            this.get_data();
        }else{
            this.rows = this.data
            this.storedRows = this.data
            this.loaded = true;
            this.dataLoaded = true;
        }
        
        //HIDE COLUMNS BASED ON PASSED PROP PAGE
        //console.log(this.page)
        if( this.page == 'lead' ){ 
            this.columns[0].hidden = true //EMAIL
        }
        
        //console.log(this.rows)
        
    },
    computed: {
    },
    methods: {
        get_data( startAtDoc = null, endBefore = null, loadSpinner = true ){
            
            if( loadSpinner ){
                this.dataLoaded = false
            }
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin, this.passed_organizationID )
            
            const db = this.$firebase.firestore();
            
            //var ref = db.collection('organizations/'+orgID+'/leads').where('email', '>', '' )
            //var ref = db.collection('organizations/'+orgID+'/leads').where('filter.email_salt', '==', true ).orderBy('filter.datetime', 'desc').limit(50)
            
            if( endBefore == null && startAtDoc == null ){
                var ref = db.collection('organizations/'+orgID+'/orders').orderBy('datetime', 'desc').limit(40)
            }else if( startAtDoc == null && endBefore != null ){
                var ref = db.collection('organizations/'+orgID+'/orders').orderBy('datetime', 'desc').endBefore( endBefore )
            }else if( startAtDoc != null && endBefore == null ){
                var ref = db.collection('organizations/'+orgID+'/orders').orderBy('datetime', 'desc').startAfter( startAtDoc ).limit(20)
            }
            
            return ref.get()
                .then((snapshot) => {
                    let results = this.rows;
                    return Promise.all(
                        snapshot.docs.map(doc => {  
                                let item = {};                
                                item = doc.data(); // will have 'todo.title'
                                item.id = doc.id;
                                /*
                                var subcollection = this.getSubcollectionDocs(doc.id);
                                return subcollection.then((docs) => {              
                                    item.tags_subcollection = docs;
                                    results.push(item);     
                                    //console.log( item )
                                    
                                    this.rows = results
                                    
                                    
                                    return results;      
                                });
                                */
                                if( item.email != "" ){
                                    results.push(item);  
                                }
                                   
                                //console.log( item )

                                results.sort((a, b) => b.datetime - a.datetime);
                            
                                this.rows = results
                                this.storedRows = results

                                return results; 
                                
                        })
                        
                    )
                    .then(results => {                        
                        //console.log(results)
                        this.loaded = true;
                        this.dataLoaded = true;
                        this.paginationOptions.setCurrentPage = this.currentPage
                        return results;   
                        //return results.length > 0 ? results[results.length - 1] : [];
                        
                    })
                
                })
            
        },
        
        get_new_data(){
            
            let last = this.storedRows[0]
            //console.log(last)
            this.currentPage = 1
            this.get_data( null, last.datetime )
            
        },
        
        load_more( ){
            
            console.log( "load more documents" )
            let startAt = this.rows[ this.rows.length - 1 ]
            console.log( "start with: "+ startAt.email )
            this.get_data( startAt.datetime, null )
            
        },
        
        onPageChange( params ){
            
            //console.log( params )
            if( this.data == null || this.data.length == 0 ){
                this.currentPage = params.currentPage;

                if( params.currentPage >= params.total ){
                    //console.log( "load more documents" )
                    let startAt = this.rows[ this.rows.length - 1 ]
                    //console.log( "start with: "+ startAt.email )
                    this.get_data( startAt.datetime, null, false )
                }
            }
                

        },
        
        searchFirestore( field, value ){
            
            this.dataLoaded = false

            //this.storedRows = this.rows
            //console.log( this.storedRows )
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin, this.passed_organizationID )
            const db = this.$firebase.firestore();

            if( field == 'tags' ){
                if( value.split(" ").length == 0 ){
                    var ref = db.collection('organizations/'+orgID+'/orders').where( 'email', '>', '' ).where("tags", 'array-contains', value)
                }else{
                    var ref = db.collection('organizations/'+orgID+'/orders').where( 'email', '>', '' ).where("tags", 'array-contains-any', value.split(" ") )
                }
            }else{
                var ref = db.collection('organizations/'+orgID+'/orders').where(field, '>=', value).where(field, '<=', value+ '\uf8ff')
            }
            

            return ref.get()
                .then((snapshot) => {
                    let results = [];
                    return Promise.all(
                        snapshot.docs.map(doc => {  
                                let item = {};                
                                item = doc.data(); // will have 'todo.title'
                                item.id = doc.id;
                            
                                results.push(item);     
                                //console.log( item )

                                results.sort((a, b) => b.datetime_created - a.datetime_created);
                            
                                this.rows = results


                                return results; 
                                
                        })
                        
                    )
                    .then(results => {                        
                        //console.log(results)
                        this.loaded = true;
                        this.dataLoaded = true;
                        return results;   
                        //return results.length > 0 ? results[results.length - 1] : [];
                        
                    })
                
                })
            
        },
        
        resetSearch(){
            this.filter = ''
            if( this.rows != this.storedRows && this.storedRows.length > 0 ){
               this.rows = this.storedRows
            }
        },
        
        searchInDB(){
            
            var regexEmail = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
            var regexPhone = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
            
            if( this.filter ){
                
                if( this.filter.startsWith( "@" ) || this.filter.startsWith("!") || this.filter.startsWith("$") ){
                    console.log("search for tags: "+this.filter )
                    this.searchFirestore( "tags", this.filter )
                }else{
                    console.log("search for email: "+this.filter )
                    this.searchFirestore( "email", this.filter )
                }
            }
                
        },
        
        updateOrderStatus( order, status ){
            
            //init org ID
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            let leadID = order.leadID
            
            this.$firebase.firestore().collection('organizations/'+orgID+'/orders').doc( order.id ).update( { status: status } )
            
            if( status == 'refunded' ){
                //DECREMENT REVENUE
                this.$firebase.firestore().collection('organizations/'+orgID+'/leads').doc(leadID).update( { revenue: this.$firebase.firestore.FieldValue.increment( -Math.abs(order.price) ) } );
            }else if( status == 'completed' ){
                //DECREMENT REVENUE
                this.$firebase.firestore().collection('organizations/'+orgID+'/leads').doc(leadID).update( { revenue: this.$firebase.firestore.FieldValue.increment( Math.abs(order.price) ) } );
            }
            
            this.$toast.success({
                title: 'Success',
                message: 'Order mared as '+status
            })
            
            order.status = status
            
        },
        
        //old
        
        getSubcollectionDocs(docID){
            
            let user =  Cookies.get('user')
            user = JSON.parse( atob( user ) )
            
            let orgID =  user.organizationID;
            
            const db = firebase.firestore();
            var ref = db.collection('organizations/'+orgID+'/leads').doc(docID).collection('tags').orderBy('datetime', 'desc');
            let items = [];
            return ref.get()
                .then(snapshot => {
                    snapshot.forEach(doc => {
                        //console.log(item.data())
                        let item = {};
                        item = doc.data(); // will have 'todo_item.title' and 'todo_item.completed'             
                        item.docID = doc.id;
                        //console.log( item )
                        items.push(item);
                    })
                    return items;
                })
        },
        
        //
        
        returnName(a){
            let name = a.firstname + " " + a.lastname;
            return name;
        },
        LeadEmail(a){
            let result = a.email
            if( a.primary_lead ){
                result += ' <b class="html-circle" title="Child lead, has a primary lead attached" >&#9679</b> '
            }
            return result;
        },
        formatDate(a){
            //return this.$moment.unix(a.datetime).format( 'MMM D, HH:mm' )
            return helper.formatDate( a.datetime, 'MMM D, HH:mm' )
        },
        returnFirstSource(a){
            //GET LAST SOURCE FROM ARRAY; ORDER DESC
            let sourceTags = []
            if( a.tags_subcollection.length > 0 ){
                let r = ''
                a.tags_subcollection.map(tag =>{
                    if( tag.type == 1 ){
                        sourceTags.push( tag )
                    }
                })
                if( sourceTags.length > 0 ){
                    r = sourceTags.slice(-1)[0] 
                    r = r.tag
                }
                return r
                
            }else{
                return ''
            }
                
        },
        returnLastSource(a){
            //GET FIRST SOURCE FROM ARRAY; ORDER DESC
            let sourceTags = []
            if( a.tags_subcollection.length > 0 ){
                let r = ''
                a.tags_subcollection.map(tag =>{
                    if( tag.type == 1 ){
                        sourceTags.push( tag )
                    }
                })
                if( sourceTags.length > 0 ){
                    r = sourceTags[0]
                    r = r.tag
                }
                return r
            }else{
                return ''
            }
            //return this.$moment.unix(a.datetime).format( 'DD/MM/YYYY HH:mm' )
        },
        renderTag(field){
            if( field.tag.length > 30 ){
                return field.tag.substring(0,30) + "..."
            }else{
                return field.tag
            }
                
        },
        renderStatus(a){
            var r;
            
            if( a.Status == 1 ){
                r = 'Active';
            }else if( a.Status == 0 ){
                r = 'Inactive';
            }else if( a.Status == 2 ){
                r = 'Blocked';
            }else if( a.Status == 3 ){
                r = 'Manually blocked';
            }
            
            return r;
        },
        routeUser(params){
            
            //console.log(params)
            /*
            let id = params.row.id;
            
            this.$router.push({
                name: 'Lead',
                params: { ID: params.row.leadID }
            }); 
            */
            this.fModalOpen( params.row );
        },
        fModalOpen( data ){
            this.modalData = data
            //this.modalData.orderID = data.id
            //this.modalData.id = data.leadID
            //this.modalLeadID = data.leadID
            this.modalState = true
        },
    },
    computed:{
    },
}
</script>

<style lang="scss" >
    
     @import '@/assets/css/atlass-datatable.scss';
     @import '@/assets/css/atlass-modal.scss';
    
    .html-circle{
        font-size: 18px;
        line-height: 14px;
    }
    
</style>


// WEBPACK FOOTER //
// src/components/orders.vue